function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import { withMedia } from 'react-media-query-hoc';
import VisibilitySensor from 'react-visibility-sensor';
import { Button } from '@domain-group/fe-co-allhomes-design-system';
import { useSendEvent, withEventBoundary } from '@domain-group/fe-co-allhomes-analytics';
import { AgentEnquiryForm } from '@domain-group/fe-co-allhomes-enquiry-form';
import StickyFooter from '@domain-group/fe-co-allhomes-sticky-footer';
var AppraisalImage = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-pa-allhomes-listing-search-results/static/appraisal_c6d13ed6.svg";
import { MixpanelLabels } from '../../analytics/constants';
import * as styles from './appraisal-cta.style';
import useAgenciesInLocalities from '../../utils/use-agencies-in-localities';
import filterPropType from '../../proptypes/filters';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AppraisalCta = _ref => {
  var media = _ref.media,
    enquiryEndpoint = _ref.enquiryEndpoint,
    filters = _ref.filters;
  var mobile = media.mobile;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    appraisalModalOpen = _useState2[0],
    setAppraisalModalOpen = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    visibilityEventSent = _useState4[0],
    setVisibilityEventSent = _useState4[1];
  var localities = filters.getLocalities();
  var agencyList = useAgenciesInLocalities({
    localities
  });
  var getEnquiryForm = () => appraisalModalOpen && /*#__PURE__*/createPortal(___EmotionJSX(AgentEnquiryForm, {
    endpointUrl: enquiryEndpoint,
    closeCallback: () => setAppraisalModalOpen(false),
    formTitle: "Request a free appraisal",
    clientType: "AGENCY",
    agencies: agencyList.nodes,
    appearance: "appraisal"
  }), document.body);
  var handleButtonClick = () => {
    sendEvent('request-a-free-appraisal-click', {
      enquiryCTA: MixpanelLabels.SOLD_FLOATING_CTA
    });
    setAppraisalModalOpen(true);
  };
  var getCardLayout = () => ___EmotionJSX("div", {
    css: styles.card
  }, ___EmotionJSX("div", {
    css: styles.content
  }, !mobile && ___EmotionJSX("img", {
    src: AppraisalImage,
    alt: ""
  }), ___EmotionJSX("div", {
    css: styles.details
  }, ___EmotionJSX("div", {
    css: styles.text
  }, ___EmotionJSX("div", {
    css: styles.header
  }, "Looking to sell your home?"), ___EmotionJSX("div", {
    css: styles.info
  }, "Get a free appraisal from a local expert.")), ___EmotionJSX(Button, {
    css: styles.button,
    appearance: "primary",
    onClick: handleButtonClick
  }, "Get a free appraisal"))));
  var handleVisibility = isVisible => {
    if (isVisible && !visibilityEventSent) {
      sendEvent('display-appraisal-cta', {
        interactionCTA: MixpanelLabels.SOLD_FLOATING_CTA
      });
      setVisibilityEventSent(true);
    }
  };
  if (mobile) {
    return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(StickyFooter, null, getCardLayout()), getEnquiryForm());
  }
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(VisibilitySensor, {
    onChange: handleVisibility
  }, getCardLayout()), getEnquiryForm());
};
AppraisalCta.propTypes = {
  media: PropTypes.shape({
    desktop: PropTypes.bool,
    mobile: PropTypes.bool
  }),
  enquiryEndpoint: PropTypes.string.isRequired,
  filters: filterPropType.isRequired
};
AppraisalCta.defaultProps = {
  media: {}
};
export default withMedia(withEventBoundary('appraisalCta')(AppraisalCta));